/* Publish by EComposer at 2026-05-26 14:12:01*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lm9k2k61d6q"]=  window.__ectimmers["ecom-lm9k2k61d6q"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-lm9k2k61d6q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lm9k2k61d6q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x9cbufbijl8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x9cbufbijl8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qt4iwn4z8oa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qt4iwn4z8oa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bajb3akom67').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bajb3akom67', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0s7xav80ttc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0s7xav80ttc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zrnyzjb97s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zrnyzjb97s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o164t82hzu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o164t82hzu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ct8tb35vj0e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ct8tb35vj0e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7r9jpzd76j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7r9jpzd76j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-82dxev2i8bc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-82dxev2i8bc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q04s1idwb4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q04s1idwb4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r6nd1vnplv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r6nd1vnplv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rdi7fu4m0t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rdi7fu4m0t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o86t7iemmf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o86t7iemmf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qiwke574g3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qiwke574g3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gadmywgj5th').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gadmywgj5th', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xzltz1gd3e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xzltz1gd3e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-86forgoj1nr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-86forgoj1nr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oby3rwexqx8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oby3rwexqx8', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-m3tqhean1dn"]=  window.__ectimmers["ecom-m3tqhean1dn"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-m3tqhean1dn"]["hkfl5hkex"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify.analytics){i.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),e.cloneNode(!0).click()}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-m3tqhean1dn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m3tqhean1dn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24p4cffmlss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24p4cffmlss', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p093479t05a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p093479t05a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mqa8lh7psu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mqa8lh7psu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-two7pm8azdm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-two7pm8azdm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wq47m2b0p38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wq47m2b0p38', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qtoid7wehpk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qtoid7wehpk', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-u9j4g32sbsp"]=  window.__ectimmers["ecom-u9j4g32sbsp"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=e.querySelector(".ecom-element.ecom-base-image"),o=e.closest(".core__row--columns");s&&(i(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-u9j4g32sbsp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9j4g32sbsp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p9qefm7i7sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p9qefm7i7sc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aon5rkyipqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aon5rkyipqm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5iy2cx5037t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5iy2cx5037t', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6u62lbx8thh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6u62lbx8thh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zr9gt8ihcn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zr9gt8ihcn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iu8qkfmldw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iu8qkfmldw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7c56c989blg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7c56c989blg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ej6ouyjg1qk"]=  window.__ectimmers["ecom-ej6ouyjg1qk"] || {};
var I,M;const t=this.$el;if(!t)return;const e=t.querySelector(".ecom-autoplay-progress svg"),i=t.querySelector(".ecom-autoplay-progress span"),n=(I=this.settings.disable_lazy)!=null?I:!1,s=this.settings,o=this.settings.slider_loop,a=this.settings.slider_center,r=this.settings.slider_center__tablet,l=this.settings.slider_center__mobile,c=this.settings.slider_group,d=this.settings.slider_items,m=this.settings.slider_group__tablet,g=this.settings.slider_items__tablet,f=this.settings.slider_group__mobile,b=this.settings.slider_items__mobile,y=this.settings.slider_speed,v=this.settings.slider_speed__tablet,w=this.settings.slider_speed__mobile,z=function(j,H={},q=""){return q=="loop"?((window.innerWidth>1024&&j.items.length<c+d||window.innerWidth<=1024&&window.innerWidth>768&&j.items.length<m+g||j.items.length<f+b)&&(H.loop=!1),H):(window.innerWidth<=1024&&window.innerWidth>768&&j[1]?H[`${q}`]=j[1]:window.innerWidth<768&&j[2]?H[`${q}`]=j[2]:j[0]&&(H[`${q}`]=j[0]),H)};let S={};e&&i&&(S={autoplayTimeLeft(j,H,q){e.style.setProperty("--progress",1-q),i.textContent=`${Math.ceil(H/1e3)}s`}});const k=t.querySelector(".ecom-swiper-container"),T=(M=this.settings.disable_touch_move)!=null?M:!0;if(!k)return;let $=JSON.parse(k.dataset.optionSwiper);$.pagination.el=t.querySelector(`.ecom-swiper-pagination[data-ecnav-id="${this.id}"]`),$.navigation.nextEl=t.querySelector(`.ecom-swiper-button-next[data-ecnav-id="${this.id}"]`),$.navigation.prevEl=t.querySelector(`.ecom-swiper-button-prev[data-ecnav-id="${this.id}"]`),$.pagination.renderBullet=(j,H)=>`<span class="${H}">
                          ${this.settings.items[j]&&this.settings.items[j].slider_pagination_image?`<img src="${this.settings.items[j].slider_pagination_image}">`:""}</span>`,S.init=function(){this.el.parentNode.classList.add("ecom-swiper-initialized-wrapper")};const F={allowTouchMove:this.isLive&&T,on:S};if($.watchSlidesProgress=!0,window.EComSwiper){let H=function(){o&&($.loop=!0,$=z(s,$,"loop")),$.centeredSlides=!1,$=z([a,r,l],$,"centeredSlides"),$=z([y,v,w],$,"speed"),j=new window.EComSwiper(k,Object.assign($,F)),$.autoplay.enabled&&(j.on("touchStart",function(Z,V){Z.params.speed=300,Z.autoplay.stop()}),j.on("touchEnd",function(Z,V){window.innerWidth>1024&&y&&(Z.params.speed=y),window.innerWidth<=1024&&window.innerWidth>768&&v?Z.params.speed=v:y&&(Z.params.speed=y),window.innerWidth<768&&w?Z.params.speed=w:v?Z.params.speed=v:y&&(Z.params.speed=y),Z.autoplay.start()})),j.on("slideChange",function(){const Z=j.activeIndex==0?j.slides.length-1:j.activeIndex-1,V=j.slides[Z];if(V){const N=V.querySelectorAll(".ecom-animation.ecom-animated");N.length&&N.forEach(function(ee){ee.classList.remove("ecom-animated","animated"),ee.classList.add("ecom-animated-slider")})}j.el&&j.slides.filter(ee=>ee.classList.contains("ecom-swiper-slide-visible")).forEach(ee=>{let U=null;ee&&ee.nodeType===1&&(U=ee.querySelectorAll(".ecom-animation.ecom-animated-slider"),U&&U.length&&U.forEach(function(Q){Q.classList.add("ecom-animated")}))})})},j=null;var A;this.isLive&&window.addEventListener("resize",function(){A&&clearTimeout(A),A=setTimeout(()=>{j.update()},200)}),this.isLive?H():setTimeout(function(){H()},200)}k.querySelectorAll("img").length&&k.querySelectorAll("img").forEach(function(j,H){n&&j.removeAttribute("loading")})

                    });
                    
                        document.querySelectorAll('.ecom-ej6ouyjg1qk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ej6ouyjg1qk', settings: {"slider_loop":true,"slider_group":1,"slider_items":1,"slider_speed":500,"items":[{"id":"ecom-utjr42euor","slider_pagination_image":null},{"id":"ecom-qjie4mkxmqe","slider_pagination_image":null},{"id":"ecom-y5ox5ii955m","slider_pagination_image":null}]},isLive: true});
                        });
                    

                })();
            
;try{
 document.addEventListener("DOMContentLoaded", function () {
  const hostname = window.location.hostname;
  const isStaging = hostname.includes("staging.cellcore.com");

  const bindAddToCartHandlers = (selector) => {
    const elements = document.querySelectorAll(`.${selector}`);
    elements.forEach(element => {
      if (element.dataset.bound) return; // Avoid double-binding
      element.dataset.bound = "true";

      element.addEventListener("click", async () => {
        event.preventDefault();
        
        const variantId = isStaging
          ? element.getAttribute("data-variant-id-staging")
          : element.getAttribute("data-variant-id-production");

        if (!variantId) {
          return;
        }

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });

          if (!response.ok) throw new Error(`Shopify Error: ${response.statusText}`);

          setTimeout(() => {
            if (typeof openCartDrawer === "function") openCartDrawer();
            if (typeof utils !== "undefined" && utils.cart?.updateCount) {
              utils.cart.updateCount();
            }
          }, 500);
        } catch (error) {
        }
      });
    });
  };

  // Initial bind (in case they’re already rendered)
  bindAddToCartHandlers("add-cart");

  // MutationObserver to watch for new nodes being added
  const observer = new MutationObserver(mutations => {
    mutations.forEach(() => {
      bindAddToCartHandlers("add-cart");
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});


} catch(error){console.error(error);}